<ng-container *ngTemplateOutlet="loading ? loadingSpinnerTemplate : contentTemplateWrap; context: context" />

<ng-template #loadingSpinnerTemplate>
	<div class="is-center-flex">
		<spinner data-test="loading-spinner">
			<p>{{ loadingText }}</p>
		</spinner>
	</div>
</ng-template>

<ng-template #contentTemplateWrap>
	@if (context) {
		<ng-template [ngTemplateOutlet]="contentTemplate" [ngTemplateOutletContext]="{ $implicit: context }" />
	} @else {
		<ng-content />
	}
</ng-template>
